module.exports = {"510502001":"南城街道","510502002":"北城街道","510502003":"大山坪街道","510502004":"邻玉街道","510502005":"蓝田街道","510502006":"茜草街道","510502007":"华阳街道","510502008":"张坝街道","510502009":"泰安街道","510502010":"况场街道","510502103":"黄舣镇","510502104":"弥陀镇","510502106":"通滩镇","510502107":"江北镇","510502108":"方山镇","510502109":"丹林镇","510502110":"分水岭镇","510502111":"石寨镇","510502400":"高新技术开发区","510502401":"酒业集中发展区","510502402":"轻工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510502.json
// module id = 2286
// module chunks = 0